// https://github.com/vuejs/vuex/blob/dev/examples/shopping-cart/store/modules/cart.js
const state =
{
    user: {userId: 0, username: '', nickname: ''},
    userPermissionIdList: [],
    userPermissionGroupIdList: []
};
const getters =
{
    isLogin(state, getters)
    {
        return !!state.user.userId;
    },
    getUsername(state, getters)
    {
        return state.user.username;
    },
    getUserId(state, getters)
    {
        return state.user.userId;
    },
    getNickname(state, getters)
    {
        return state.user.nickname;
    }
};
const mutations =
{
    setSessionUser(state, {userId, username, nickname})
    {
        state.user.userId = userId;
        state.user.username = username;
        state.user.nickname = nickname;
    },
    setUserPermissionIdList(state, userPermissionIdList)
    {
        state.userPermissionIdList = userPermissionIdList;
    },
    setUserPermissionGroupIdList(state, userPermissionGroupIdList)
    {
        state.userPermissionGroupIdList = userPermissionGroupIdList;
    }

};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/session.js